module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PlanoEngine', {
    attrs: {
      "catalogPanes": _vm.favoriteCatalogPanes,
      "catalogItems": _vm.catalogItems,
      "systemType": _vm.systemType
    },
    on: {
      "search-changed": function (e) { return _vm.$emit('search-changed', e); },
      "save": function($event) {
        _vm.$emit('save');
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77e779fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/favorite-plano-engine.vue
// module id = 3278
// module chunks = 0